import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Collapse } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import {
  downloadAllPlayers,
  getPlayers,
  getSession,
  getStatus,
  PaidPlayerPackageChange,
} from "../../../services/academicService";
import RegisterQrModal from "../../components/qr/RegisterQrModal";
import ForgetPasswordModal from "../../components/superAdmin/ForgetPasswordModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PlayerReciptModal from "../../components/PlayerReciptModal";
import AssignCoachModal from "../../components/AssignCoachModal";
import PlayerPaymentModal from "../../components/PlayerPaymentModal";
import PlayerOnlinePaymentModal from "../../components/PlayerOnlinePaymentModal";
import { toast } from "react-toastify";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getPublicAgeCategory,
  getPublicDueTypeList,
  getPublicPaymentStatus,
} from "../../../services/publicService";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Player Id", sortingVale: "id" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Age", sortingVale: "age" },
  { heading: "Gender", sortingVale: "gender" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Mobile", sortingVale: "mobile" },
  { heading: "Package", sortingVale: "package" },
  { heading: "Admission Date", sortingVale: "join" },
  { heading: "Amount Deposited", sortingVale: "amountdeposited" },
  { heading: "Payment Status", sortingVale: "paymentstatus" },
  { heading: "Due Amount", sortingVale: "dueamount" },
  { heading: "Next Dues Date", sortingVale: "nextduedate" },
  { heading: "Renewal Date", sortingVale: "duedate" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const AllPlayers = () => {
  const [forgetModal, setForgetModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);

  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [qrCodeModal, setQrCodeModal] = useState(false);
  const [currentStart, setCurrentStart] = useState(0);
  const [paymentModal, setPaymentModal] = useState(false);
  const [onlinePaymentModal, setOnlinePaymentModal] = useState(false);
  const [reciptModal, setReciptModal] = useState(false);
  const [assignCoachModal, setAssignCoachModal] = useState(false);

  //filter
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [dueList, setDueList] = useState([]);
  const [ageCategory, setAgeCategory] = useState([]);
  const [selectedDueList, setSelectedDueList] = useState(null);
  const [selectedAgeCategory, setSelectedAgeCategory] = useState(null);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(null);
  const [open, setOpen] = useState(false);

  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const baseUrl = window.location.origin + "/public/player-registration";
  const formatDate = (date) => {
    if (!date) return null;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getPlayers(
        page,
        size,
        search,
        selectedDueList,
        selectedAgeCategory,
        selectedPaymentStatus,
        formatDate(startDate),
        formatDate(endDate),
      );
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({
      page,
      size,
      search,
      selectedDueList,
      selectedAgeCategory,
      selectedPaymentStatus,
      startDate,
      endDate,
    });
  }, [
    page,
    size,
    search,
    selectedDueList,
    selectedAgeCategory,
    selectedPaymentStatus,
    startDate,
    endDate,
  ]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "email":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "landLine":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.landLine || "").localeCompare(b.landLine || "")
            : (b.landLine || "").localeCompare(a.landLine || ""),
        );
        break;

      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.phone || "").localeCompare(b.phone || "")
            : (b.phone || "").localeCompare(a.phone || ""),
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  const downloadExcel = async () => {
    try {
      const res = await downloadAllPlayers(search);

      const formattedData = res?.content?.map((data, index) => ({
        "S.No": index + 1,
        Name: data.name,
        Age: data.age,
        Sex: data.sex,
        Email: data.email,
        Phone: data.phone,
        "Package Type": data.packageType,
        "Date Of Joining": data.dateOfJoining,
        "Amount Deposited": data.amountDeposited,
        "Payment Status": data.paymentStatus,
        "Due Amount": data.dueAmount,
        "Due Date": data.dueDate,
        Status: data.status,
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "members.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  useEffect(() => {
    fetchDueList();
    fetchPaymentStatus();
    fetchAgeCategory();
  }, []);

  async function fetchDueList() {
    try {
      const res = await getPublicDueTypeList();
      setDueList(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchPaymentStatus() {
    try {
      const res = await getPublicPaymentStatus();
      setPaymentStatus(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchAgeCategory() {
    try {
      const res = await getPublicAgeCategory();
      setAgeCategory(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  return (
    <>
      <PageTitle activeMenu={"All Players"} motherMenu={"Players"} />
      <div className="filter cm-content-box box-primary">
        <div className={`content-title`} onClick={() => setOpen(!open)}>
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
            >
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="form-group mb-0">
                    <label className="form-label d-block text-start mb-1">
                      Due List
                    </label>
                    <Select
                      isSearchable={false}
                      options={[
                        { label: "Select Due List", value: "" },
                        ...dueList,
                      ]}
                      className="custom-react-select"
                      onChange={(e) => setSelectedDueList(e?.value)}
                      placeholder="Select Due List"
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="form-group mb-0">
                    <label className="form-label d-block text-start mb-1">
                      Start Date
                    </label>
                    <div className="w-100 d-block">
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          setEndDate(null); // reset end date
                        }}
                        maxDate={new Date()}
                        dateFormat="yyyy-MM-dd"
                        className="form-control w-100"
                        wrapperClassName="d-block w-100"
                        placeholderText="Select start date"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                  <div className="form-group mb-0">
                    <label className="form-label d-block text-start mb-1">
                      End Date
                    </label>
                    <div className="w-100 d-block">
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        minDate={startDate}
                        maxDate={
                          startDate
                            ? new Date(
                              new Date(startDate).setDate(
                                startDate.getDate() + 90,
                              ),
                            )
                            : new Date()
                        }
                        disabled={!startDate}
                        dateFormat="yyyy-MM-dd"
                        className="form-control w-100"
                        wrapperClassName="d-block w-100"
                        placeholderText="Select end date"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                  <div className="form-group mb-0">
                    <label className="form-label d-block text-start mb-1">
                      Age Category
                    </label>
                    <Select
                      isSearchable={false}
                      options={[
                        { label: "Select Age Category", value: "" },
                        ...ageCategory,
                      ]}
                      className="custom-react-select"
                      onChange={(e) => setSelectedAgeCategory(e?.value)}
                      placeholder="Select Age Category"
                    />
                  </div>
                </div>

                <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                  <div className="form-group mb-0">
                    <label className="form-label d-block text-start mb-1">
                      Payment Status
                    </label>
                    <Select
                      isSearchable={false}
                      options={[
                        { label: "Select Payment Status", value: "" },
                        ...paymentStatus,
                      ]}
                      className="custom-react-select"
                      onChange={(e) => setSelectedPaymentStatus(e?.value)}
                      placeholder="Select Payment Status"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <h4 className="card-title mb-0">Players</h4>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setQrCodeModal(true)}
                      >
                        QR Code
                      </button>

                      <Link
                        to={"/admin/add-player"}
                        className="btn btn-sm btn-primary"
                      >
                        + Add New
                      </Link>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => downloadExcel()}
                      >
                        Download
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center mb-0">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label className="d-flex align-items-center mb-0">
                            <span className="me-2 text-nowrap">Search :</span>
                            <input
                              type="search"
                              className="form-control form-control-sm"
                              placeholder="Search..."
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL & STICKY ACTION COLUMN */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100 text-nowrap"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => {
                                const isAction = item.sortingVale === "action";
                                return (
                                  <th
                                    key={ind}
                                    onClick={() => {
                                      if (isAction) return;
                                      SotingData(item.sortingVale);
                                      setIconDate((prevState) => ({
                                        complete: !prevState.complete,
                                        ind: ind,
                                      }));
                                    }}
                                    style={{
                                      cursor: !isAction ? "pointer" : "default",
                                      ...(isAction
                                        ? {
                                          // position: "sticky",
                                          // right: 0,
                                          // backgroundColor: "#f8f9fa",
                                          // zIndex: 3,
                                          // boxShadow:
                                          //   "-3px 0 6px -2px rgba(0, 0, 0, 0.1)",
                                          // textAlign: "center",
                                        }
                                        : {}),
                                    }}
                                  >
                                    {item.heading}
                                    {!isAction && (
                                      <span>
                                        {ind !== iconData.ind && (
                                          <i
                                            className="fa fa-sort ms-2 fs-12"
                                            style={{ opacity: "0.3" }}
                                          />
                                        )}
                                        {ind === iconData.ind &&
                                          (iconData.complete ? (
                                            <i
                                              className="fa fa-arrow-down ms-2 fs-12"
                                              style={{ opacity: "0.7" }}
                                            />
                                          ) : (
                                            <i
                                              className="fa fa-arrow-up ms-2 fs-12"
                                              style={{ opacity: "0.7" }}
                                            />
                                          ))}
                                      </span>
                                    )}
                                  </th>
                                );
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{currentStart * size + ind + 1}</td>
                                  <td>{data?.serialNumber}</td>
                                  <td>{data?.name}</td>
                                  <td>{data?.age}</td>
                                  <td>{data?.sex}</td>
                                  <td>{data?.email}</td>
                                  <td>{data?.phone}</td>
                                  <td>
                                    {data?.subscription?.packageType?.name}
                                  </td>
                                  <td>{data?.dateOfJoining}</td>
                                  <td>{data?.amountDeposited}</td>
                                  <td>{data?.paymentStatus}</td>
                                  <td>{data?.dueAmount}</td>
                                  <td>
                                    {data?.playerSubscription?.nextDueDate ||
                                      "-"}
                                  </td>
                                  <td>{data?.playerSubscription?.endDate}</td>
                                  <td>{data?.status}</td>
                                  <td
                                    style={{
                                      // position: "sticky",
                                      // right: 0,
                                      // backgroundColor: "#ffffff",
                                      // zIndex: 2,
                                      // boxShadow:
                                      //   "-3px 0 6px -2px rgba(0, 0, 0, 0.1)",
                                      // textAlign: "center",
                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                      <Link
                                        to="/admin/add-player"
                                        state={{ user: data, mode: "edit" }}
                                        className="btn btn-s sharp btn-primary"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil" />
                                      </Link>

                                      <Dropdown>
                                        <Dropdown.Toggle
                                          variant="success"
                                          className="light sharp i-false"
                                        >
                                          {svg1}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          renderOnMount
                                          popperConfig={{
                                            strategy: "fixed",
                                            modifiers: [
                                              {
                                                name: "flip",
                                                options: {
                                                  fallbackPlacements: [
                                                    "bottom-end",
                                                    "top-end",
                                                  ],
                                                },
                                              },
                                              {
                                                name: "preventOverflow",
                                                options: {
                                                  boundary: "viewport",
                                                },
                                              },
                                            ],
                                          }}
                                        >
                                          <Dropdown.Item
                                            as={Link}
                                            to="/admin/about-player"
                                            state={{ user: data }}
                                          >
                                            View
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            onClick={() => {
                                              setSelectedUser(data);
                                              setAssignCoachModal(true);
                                            }}
                                          >
                                            Assign Coach
                                          </Dropdown.Item>

                                          <Dropdown.Item
                                            onClick={() => {
                                              if (data?.subscription?.id) {
                                                setSelectedUser(data);
                                                setPaymentModal(true);
                                              } else {
                                                toast.warning(
                                                  "Please configure package for this player.",
                                                );
                                              }
                                            }}
                                          >
                                            Payment
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            onClick={() => {
                                              setSelectedUser(data);
                                              setOnlinePaymentModal(true);
                                            }}
                                          >
                                            Package Config
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            onClick={() => {
                                              setSelectedUser(data);
                                              setReciptModal(true);
                                            }}
                                          >
                                            Download Receipt
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td
                                  colSpan={theadData.length}
                                  className="text-center py-4"
                                >
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td
                                  colSpan={theadData.length}
                                  className="text-center py-4"
                                >
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages || 1}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${page === 0 ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${page + 1 >= totalPages ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>

              {/* GRID VIEW */}
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {userData?.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          <Dropdown align="end" drop="up">
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link
                                  to="/admin/add-player"
                                  state={{ user: item, mode: "edit" }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={IMAGES?.smallpic2}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <h3 className="mt-4 mb-1">{item?.name}</h3>

                            <ul className="list-group mb-3 list-group-flush">
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Email:</span>
                                <span className="mb-0">{item?.email}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Phone:</span>
                                <span>{item?.phone}</span>
                              </li>
                              <li className="list-group-item px-0 d-flex justify-content-between">
                                <span className="mb-0">Package:</span>
                                <span>{item?.packageType}</span>
                              </li>
                            </ul>

                            <Link
                              to="/admin/about-player"
                              state={{ user: item }}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {loading && (
                    <div className="col-12 text-center my-3">Loading...</div>
                  )}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>

      <ForgetPasswordModal
        show={forgetModal}
        onClose={() => setForgetModal(false)}
        userData={selectedUser}
      />

      <RegisterQrModal
        show={qrCodeModal}
        onClose={() => setQrCodeModal(false)}
        url={baseUrl}
        title={"Registration"}
      />

      <AssignCoachModal
        show={assignCoachModal}
        onClose={() => setAssignCoachModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setAssignCoachModal(false);
          fetchUserData({ page, size, search });
        }}
      />
      <PlayerPaymentModal
        show={paymentModal}
        onClose={() => setPaymentModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setPaymentModal(false);
          fetchUserData({ page, size, search });
        }}
      />
      <PlayerOnlinePaymentModal
        show={onlinePaymentModal}
        onClose={() => setOnlinePaymentModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setOnlinePaymentModal(false);
          fetchUserData({ page, size, search });
        }}
      />
      <PlayerReciptModal
        show={reciptModal}
        onClose={() => setReciptModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setReciptModal(false);
          fetchUserData({ page, size, search });
        }}
      />
    </>
  );
};

export default AllPlayers;
